import commonPageService from 'pcCommon/services/commonPageService';
import { IUserInfo } from 'globalCommon/services/getUserInfo';
import { syncRender } from 'globalCommon/services/syncRender';
const dialogEduGlobal = require('globalCommon/html/dialogEduGlobal.html');

import './reset.css';
import './btn-new.css';
import './style.css';
import './home-common.css';

(window as any).showEduTutorial = function () {
    const dialog = document.createElement('div');
    dialog.innerHTML = dialogEduGlobal;
    dialog.classList.add('pc');
    document.body.appendChild(dialog);
    dialog.querySelectorAll('.close-edu-global').forEach((element) => {
        (element as HTMLElement).onclick = () => {
            document.body.removeChild(dialog);
        };
    });
};

const init = () => {
    const cb = (userInfo: IUserInfo) => {
        const applyDesc = document.querySelector('.edu-apply-desc');
        /** 这句多语必须要用 ``，因为翻译结果中有单引号，也有双引号，导致代码解析不对 */
        applyDesc && (applyDesc.innerHTML = `Всего два шага, чтобы присоединиться к Программе развития образования UMU и пользоваться продуктами <span>Бесплатной образовательной версией</span> `);
        if (userInfo?.teacher_info?.teacher_status === 6) {
            const certificationBtn = document.querySelector('.btn-certification') as HTMLElement;
            certificationBtn && (certificationBtn.style.display = 'none');
        }
    };
    commonPageService({ cb, renderAfter: syncRender });
};

init();
